Vue.component('streamerBattles', {
  template: templates.streamerBattles,
  data() {
    return {
      model: {
        state: false,
        teamName: null,
        cooldown: null,
        intervalId: null,
        teams: [],
        expandedRow: null,
        showTimer: null,
        hasResults: true,
        validName: true,
        hasResult: false,
        isLoading: false,
      },
      cancelTokenSource: null
    };
  },
  created() {
    const c = this;
    c.connect();
  },
  mounted() {
    const c = this;
    c.get();
    c.getStreamerTeams();
    c.startTimers();
    // c.startSendingData();

    c.$root.$on('streamerTeamAccepted', data => {
      c.getStreamerTeams();
    })
  },
  beforeDestroy() {
    const c= this;
    if (c.ws) {
      c.ws.close();
    }

    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    getCardImage(card) {
      return  `${root}/images/cards/${card.cardId}.png`;
    },
    cardNames(cards) {
      return cards.map(card => card.name).join(', ');
    },
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
        // c.messages.push(event.data);
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    sendMessage(state) {
      
      const c = this;

        const messageData = {
          to: utils.cookies.get('user_id'),
          channelId: utils.cookies.get('channelId'),
          message: state,
        };
      
      c.ws.send(JSON.stringify(messageData));
    
    },

    get() {
      const c = this;

      // if (this.cancelTokenSource) {
      //   this.cancelTokenSource.cancel('Previous request canceled.');
      // }

      // c.cancelTokenSource = axios.CancelToken.source();

      userService
        .getStreamerBattleState()
        .then((res) => {
          const { state } = res.data;
          let val = parseInt(state);

          //c.model.state = val === 1 ? true : false;
          c.model.cooldown = res.data.cooldown;
          c.model.isLoading = true;
        })
        .catch((error) => {
          console.log(error)
          c.model.isLoading = true;
        });
    },
    getStreamerTeams(){
      const c = this;

      // if (this.cancelTokenSource) {
      //   this.cancelTokenSource.cancel('Previous request canceled.');
      // }

      // c.cancelTokenSource = axios.CancelToken.source();

      userService.getStreamerTeam()
        .then((res) => {
          
          c.model.isLoading = true;
          c.model.hasResult = true;
          // for (let d of res.data) {
          //   data[`${d.id}`] = d;
          // }


          c.model.teams = res.data;

          console.log(c.model)

          
   
          
        })
      .catch((error) => {
        c.model.isLoading = true;
        console.log(error)
        // if (axios.isCancel(error)) {
        //   console.log('Request canceled:', error.message);
        // } else {
        //   console.error(error);
        // }
      })
    },
    toggleDetails(index){
      const c = this;

      c.model.expandedRow = c.model.expandedRow === index ? null : index;
      let data = c.model.teams[`${index}`];
      console.log(index)
      console.log(data)

    },
    startTimers() {
      const c = this;
      setInterval(() => {
          if (c.model.cooldown > 0) {
           
            c.model.cooldown -= 1; // Decrease remaining time by 1 second
          }
      }, 1000);
      
    },
    formatTime(time) {
      // Hours, minutes and seconds
      var hrs = ~~(time / 3600);
      var mins = ~~((time % 3600) / 60);
      var secs = ~~time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";
      if (hrs > 0) {
          ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }
      ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      ret += "" + secs;
      return ret;
    },
    saveStreamerBattleState(e) {
      const c = this;
      let state = e.target.checked;
      let data = {
        value: state ? 1 : 0,
        openStream: false,
      };

      userService
        .toggleStreamerBattle(data)
        .then((res) => {
          const { state } = res.data;
          let val = parseInt(state);

          c.model.state = val === 1 ? true : false;

          if (c.model.state) {
            utils.alert.success('Streamer recruiting on');
          } else {
            utils.alert.show('Streamer recruiting off');
            c.model.cooldown = null;
            c.sendMessage('off');
          }
        })
        .catch((error) => console.log(error));
    },
    openStream(teamId,index){
      const c = this;

      let data = {
        value: true,
        openStream: true,
        teamId: teamId,
        index: index
      };

      userService
      .toggleStreamerBattle(data)
      .then((res) => {
        if(res.data.message){
          utils.alert.error(res.data.message);
        }
        else{
          c.getStreamerTeams();
          // c.model.showTimer = c.model.showTimer === index ? null : index;
          // c.model.cooldown = res.data.timer;
          c.sendMessage('on');
       
          // c.startSendingData();
        }
       
      })
      .catch((error) => {
        console.log(error)
      });

    },
    cancelStream(teamId, index){
      const c = this;

      let data = {
        value: false,
        openStream: false,
        teamId: teamId,
        index: null
      };

      userService
      .toggleStreamerBattle(data)
      .then((res) => {
        if(res.data.message){
          utils.alert.error(res.data.message);
        }
        else{
          c.getStreamerTeams();
          // c.model.showTimer = c.model.showTimer === index ? null : index;
          c.model.cooldown = res.data.timer;
          c.sendMessage('off');
       
          // c.startSendingData();
        }
       
      })
      .catch((error) => {
        console.log(error)
      });
    },
    addTeam(){  
      const c = this;

      c.model.state = true;

    },
    cleanName() {
      const c = this;

      c.model.teamName = c.model.teamName.replace(/[\W_]+/g, '').trim();

      if (BANNEDWORDS.some(function(v) { return c.model.teamName.toLocaleLowerCase().indexOf(v) >= 0; })) {
        utils.alert.error("Let's keep it a bit clean.");
        c.model.validName = false;
        c.model.teamvalidate = 'Invalid Name';
      } else {

        c.model.teamvalidate = '';

        let data = {
          teamName: c.model.teamName
        }

        userService.getValidTeams(data)
        .then(function(response){

          if (response.data.status == 400) {
              c.model.teamvalidate = response.data.message; 
              c.model.validName = false; 
            } else {
              c.model.teamvalidate = response.data.message;
              c.model.validName = true; 
            }

            console.log(response)
            console.log(c.model)
        })
        .catch(function(error){

          // c.model.validName = false;
          // console.log(error.response.data.message)
          // if (error.response) {
          //   c.model.teamvalidate = error.response.data.message;
          // } else if (error.request) {
          //     console.error('No response received:', error.request);
          // } else {
          //     console.error('Error:', error.message);
          // }

        })



      }
      
    },
    cancelTeam(){
      const c = this;

      c.model.state = false;
    },
    saveStreamTeam(){   
      const c = this;

      let data = {
        teamName: c.model.teamName
      };

      userService
      .saveStreamteam(data)
      .then((res) => {

        if(res.data.id){
          c.getStreamerTeams()
          c.model.state = false;
          c.model.teamName = null;
          utils.alert.success('Team Saved!');
        }
        else{
          utils.alert.error(res.data.message);
        }

  
        
        // c.model.cooldown = res.data.timer;
        // c.sendMessage('on');
     
        // c.startSendingData();
      })

    },
  //   startSendingData() {
  //     const c = this;

  //     if (c.model.interval) {
  //         console.log("Data sending is already in progress.");
  //         return;
  //     }

  //     const sendData = () => {
     
  //       if (c.model.cooldown === null) {
  //           c.stopSendingData();
  //       }
  //       else{
  //         c.sendMessage('timer');
  //       }
   
  //     };

  //     c.model.interval = setInterval(sendData, 120000);

  //     console.log(c.model.cooldown);

  // },
  stopSendingData() {
    const c = this;
      clearInterval(c.model.interval);
      c.model.interval = null;
      console.log("Stopped sending data.");
      c.sendMessage('stop');
  },
  removeUser(data){

    const c = this;
    
    let reqData = {
      id: data.id,
      twitchId: data.twitchId,
      teamName: data.teamName,
      streamerUserName: utils.cookies.get('user_login')
    };

    userService
    .cancelStreamPlayer(reqData)
    .then((res) => {
      utils.alert.error(res.data.message);
      c.get()
      c.getStreamerTeams();
    })
    .catch((error) => {
      console.log(error);
    });

  },
  cardNames(cards){
    return cards.map(card => `${card.name}(${card.tier})`).join(', ');
  },
  enableFaction(data){
    const c = this;
    
    userService.enableStreamerFaction(data)
    .then(function(response){
      utils.alert.success('Faction Enabled!');
    })
    .catch(function(error){
      console.log(error)
    })
  },
  hasResults(team){
    console.log(team)
  }

  },
});
